import { isAxiosError } from 'axios'
import { z } from 'zod'

const dataverseErrorSchema = z.object({
  error: z.object({ message: z.string() }),
})

export const KEEP_SUPPLIES_UNCHANGED_FIELD = 'dsy_keepsuppliesunchanged'
// dsy_branch.dsy_defaulttaxcode — absent in orgs the column hasn't reached (sandbox loads the prod CPQ).
export const BRANCH_DEFAULT_TAX_CODE_FIELD = 'dsy_defaulttaxcode'

export function isQuoteFieldMissingError(error: unknown, field: string) {
  if (!isAxiosError(error) || error.response?.status !== 400) return false

  const parsed = dataverseErrorSchema.safeParse(error.response.data)
  return parsed.success && parsed.data.error.message.includes(`Could not find a property named '${field}'`)
}

export function isKeepSuppliesUnchangedFieldMissingError(error: unknown) {
  return isQuoteFieldMissingError(error, KEEP_SUPPLIES_UNCHANGED_FIELD)
}
